module.exports = __webpack_public_path__ + "img/Vector.c7b4741d.svg";